import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import Grid from "../../elements/Grid";
import Header from "../../fragments/Header";
import Heading from "../../elements/Heading";
import HorizontalOverflow from "../../modules/HorizontalOverflow";
import Pagination from "../../modules/Pagination";
import { Rank } from "../../core/types";
import VerticalSpacing, { VerticalSpacingSizes } from "../../elements/VerticalSpacing";
import { getClassNameFactory, getRehydratableName } from "../../utilities";
import Table from "./components/Table";
import TagFilter from "./components/TagFilter"; // to avoid pulling in lodash get this get fn lets us use similar behavior.

var get = function get(fn) {
  try {
    return fn();
  } catch (e) {
    return undefined; // eslint-disable-line no-undefined
  }
};

var TableWithFilters = /*#__PURE__*/function (_Component) {
  _inherits(TableWithFilters, _Component);

  var _super = _createSuper(TableWithFilters);

  function TableWithFilters(props) {
    var _this;

    _classCallCheck(this, TableWithFilters);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "paginationResultSummary", null);

    _defineProperty(_assertThisInitialized(_this), "scrollTimeout", null);

    _defineProperty(_assertThisInitialized(_this), "isSupportsSmoothScroll", true);

    _defineProperty(_assertThisInitialized(_this), "getPaginationMarkup", function (placement) {
      var _this$state$paginatio = _this.state.pagination,
          currentPage = _this$state$paginatio.currentPage,
          pages = _this$state$paginatio.pages;
      var pagesNavigableOnSide = _this.props.pagesNavigableOnSide;
      var getClassName = _this.getClassName;

      var PaginationWrapper = _this.getPaginationWrapper(placement);

      var topPagination = placement === "top";
      var pageRange = 2 * pagesNavigableOnSide + 1; // eslint-disable-line no-magic-numbers

      if (pages > 1) {
        return /*#__PURE__*/React.createElement(PaginationWrapper, null, /*#__PURE__*/React.createElement("div", {
          className: getClassName({
            descendantName: "paginationInnerWrapper"
          })
        }, topPagination ? /*#__PURE__*/React.createElement(Pagination, {
          borderlessAtStandard: true,
          condensed: true,
          condensedAtNarrow: false,
          initialPage: currentPage,
          onPageChanged: _this.goToPage,
          pageCount: pages,
          pageRangeCount: pageRange
        }) : /*#__PURE__*/React.createElement(Pagination, {
          initialPage: currentPage,
          onPageChanged: _this.goToPage,
          pageCount: pages,
          pageRangeCount: pageRange
        })));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getPaginationResultSummaryText", function () {
      var _this$props = _this.props,
          paginationResultSummaryText = _this$props.paginationResultSummaryText,
          rowsPerPage = _this$props.rowsPerPage;
      var pagination = _this.state.pagination;
      return paginationResultSummaryText.replace("{1}", "".concat(pagination.rows > 0 ? (pagination.currentPage - 1) * rowsPerPage + 1 : 0, "-").concat(pagination.currentPage * rowsPerPage < pagination.rows ? pagination.currentPage * rowsPerPage : pagination.rows)).replace("{2}", pagination.rows);
    });

    _defineProperty(_assertThisInitialized(_this), "getPaginationWrapper", function (placement) {
      return function (_ref) {
        var children = _ref.children;
        var topPagination = placement === "top";

        if (!topPagination) {
          return /*#__PURE__*/React.createElement(VerticalSpacing, {
            size: VerticalSpacingSizes.XS
          }, children);
        }

        return children;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "goToPage", function (page) {
      // Create a deep copy
      var pagination = JSON.parse(JSON.stringify(_this.state.pagination));

      if (page >= 1 && page <= pagination.pages) {
        pagination.currentPage = page;

        _this.setState({
          pagination: pagination
        });

        _this.handlePageChange();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageChange", function () {
      var delay = 100;

      if (_this.paginationResultSummary) {
        clearTimeout(_this.scrollTimeout);
        _this.scrollTimeout = setTimeout(function () {
          var rect = _this.paginationResultSummary.getBoundingClientRect();

          var resultSummaryCointainerTopPosition = rect.y || rect.top; // IE 11 does not return back x/y values, in that case need to fallback to top/left values.

          var windowScrollY = window.scrollY || window.pageYOffset; // IE 11 does not support window scrollY, in that case need to fallback to pageYOffset value.

          if (_this.isSupportsSmoothScroll) {
            window.scrollTo({
              top: resultSummaryCointainerTopPosition + windowScrollY,
              behavior: "smooth"
            });
          } else {
            window.scrollTo(0, resultSummaryCointainerTopPosition + windowScrollY);
          }
        }, delay);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkSupportsSmoothScroll", function () {
      var supports = false;

      try {
        var div = document.createElement("div");
        div.scrollTo({
          top: 0,

          get behavior() {
            supports = true;
            return "smooth";
          }

        });
      } catch (err) {
        supports = false;
      }

      return supports;
    });

    _this.getClassName = getClassNameFactory(TableWithFilters.displayName); // Create a deep copy

    var data = JSON.parse(JSON.stringify(_this.props.data)); // Add keys to table rows and cells

    _this.addKeys(data); // Change array order of the filters to match they display order
    // This needs to be subsequent to adding keys addKeys()


    if (data.filter && data.filter.cells) {
      data.filter.cells.sort(function (a, b) {
        if (typeof a.displayOrder === "number" && typeof b.displayOrder === "number") {
          return a.displayOrder - b.displayOrder;
        }

        return 0;
      });
    } // Initialize pagination


    var rows = get(function () {
      return data.table.bodies[0].rows.length;
    }) || 0;
    _this.state = {
      filter: data.filter || {},
      table: data.table || {},
      pagination: {
        currentPage: 1,
        pages: Math.ceil(rows / _this.props.rowsPerPage),
        rows: rows
      }
    };
    _this.isSupportsSmoothScroll = _this.checkSupportsSmoothScroll();
    return _this;
  }

  _createClass(TableWithFilters, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // Initialize pagination. Needed for refresh in Storybook.
      var rows = get(function () {
        return _this2.props.data.table.bodies[0].rows.length;
      }) || 0;

      if (this.props.rowsPerPage !== prevProps.rowsPerPage) {
        this.setState({
          pagination: {
            currentPage: 1,
            pages: Math.ceil(rows / this.props.rowsPerPage),
            rows: rows
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          filter = _this$state.filter,
          table = _this$state.table,
          pagination = _this$state.pagination;
      var _this$props2 = this.props,
          filtersHideSelectedOptions = _this$props2.filtersHideSelectedOptions,
          filtersNoOptionsMessage = _this$props2.filtersNoOptionsMessage,
          filtersPlaceholder = _this$props2.filtersPlaceholder,
          infoText = _this$props2.infoText,
          isMulti = _this$props2.isMulti,
          paginationResultSummaryText = _this$props2.paginationResultSummaryText,
          pagesNavigableOnSide = _this$props2.pagesNavigableOnSide,
          noResultsMessage = _this$props2.noResultsMessage,
          rowsPerPage = _this$props2.rowsPerPage,
          subtitleHeadingRank = _this$props2.subtitleHeadingRank,
          title = _this$props2.title,
          titleHeadingRank = _this$props2.titleHeadingRank;
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        "data-table-data": JSON.stringify(this.props.data),
        "data-filters-hide-selected-options": JSON.stringify(filtersHideSelectedOptions),
        "data-filters-no-options-message": JSON.stringify(filtersNoOptionsMessage),
        "data-filters-placeholder": JSON.stringify(filtersPlaceholder),
        "data-info-text": JSON.stringify(infoText),
        "data-no-results-message": JSON.stringify(noResultsMessage),
        "data-pages-navigable-on-side": JSON.stringify(pagesNavigableOnSide),
        "data-pagination-result-summary-text": JSON.stringify(paginationResultSummaryText),
        "data-rehydratable": getRehydratableName(TableWithFilters.displayName),
        "data-rows-per-page": JSON.stringify(rowsPerPage),
        "data-subtitle-heading-rank": JSON.stringify(subtitleHeadingRank),
        "data-title": JSON.stringify(title),
        "data-title-heading-rank": JSON.stringify(titleHeadingRank)
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VerticalSpacing, {
        size: VerticalSpacingSizes.L
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "filtersPanel"
        })
      }, title && /*#__PURE__*/React.createElement(VerticalSpacing, {
        size: VerticalSpacingSizes.XS
      }, /*#__PURE__*/React.createElement(Heading, {
        type: "l",
        rank: titleHeadingRank
      }, title)), infoText && /*#__PURE__*/React.createElement(VerticalSpacing, null, /*#__PURE__*/React.createElement(Header, {
        heading: /*#__PURE__*/React.createElement(Heading, {
          rank: subtitleHeadingRank,
          type: "m"
        }, infoText)
      })), /*#__PURE__*/React.createElement(Grid, {
        variant: "even-2"
      }, get(function () {
        return filter.cells;
      }) && filter.cells.map(function (cell, index) {
        var key = typeof cell.key === "undefined" ? index : cell.key;
        var label = get(function () {
          return table.head.rows[0].cells[key].content;
        }) || "";
        return cell.display && /*#__PURE__*/React.createElement(Grid.Item, {
          key: key.toString()
        }, /*#__PURE__*/React.createElement(TableWithFilters.TagFilter, {
          index: index,
          handleChange: function handleChange(optionsSelected) {
            return _this3.handleChange(optionsSelected, key);
          },
          hideSelectedOptions: filtersHideSelectedOptions,
          isMulti: isMulti,
          label: label,
          options: _this3.getOptions(key),
          placeholder: filtersPlaceholder,
          noOptionsMessage: filtersNoOptionsMessage,
          value: get(function () {
            return filter.cells.find(function (cellFilter) {
              return cellFilter.key === key;
            }).optionsSelected;
          }) || []
        }));
      })))), /*#__PURE__*/React.createElement(VerticalSpacing, {
        size: VerticalSpacingSizes.XS
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "paginationResultSummary"
        }),
        name: "paginationResultSummary",
        ref: function ref(el) {
          _this3.paginationResultSummary = el;
        }
      }, this.getPaginationResultSummaryText(), this.getPaginationMarkup("top"))), /*#__PURE__*/React.createElement(VerticalSpacing, {
        size: VerticalSpacingSizes.M
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "table"
        })
      }, /*#__PURE__*/React.createElement(HorizontalOverflow, null, /*#__PURE__*/React.createElement(TableWithFilters.Table, {
        data: this.getPaginatedTable()
      })), pagination.pages < 1 && /*#__PURE__*/React.createElement("p", {
        className: this.getClassName({
          descendantName: "noResultsMessage"
        })
      }, noResultsMessage))), this.getPaginationMarkup()));
    }
  }, {
    key: "addKeys",
    value: function addKeys(_ref2) {
      var filter = _ref2.filter,
          table = _ref2.table;

      if (get(function () {
        return table.head.rows;
      })) {
        table.head.rows.forEach(function (row, indexRow) {
          row.key = indexRow;

          if (row.cells) {
            row.cells.forEach(function (cell, indexCell) {
              cell.key = indexCell;
            });
          }
        });
      }

      if (get(function () {
        return table.bodies[0].rows;
      })) {
        table.bodies[0].rows.forEach(function (row, indexRow) {
          row.key = indexRow;

          if (row.cells) {
            row.cells.forEach(function (cell, indexCell) {
              cell.key = indexCell; // Link filters with table cells via "key" attribute

              if (indexRow === 0) {
                if (get(function () {
                  return filter.cells && filter.cells[indexCell];
                })) {
                  filter.cells[indexCell].key = indexCell;
                }
              }
            });
          }
        });
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions(key) {
      var options = [];
      var table = this.state.table;

      if (get(function () {
        return table.bodies;
      })) {
        table.bodies.forEach(function (body) {
          if (body.rows) {
            body.rows.forEach(function (row) {
              if (row.cells && row.cells[key]) {
                var option = row.cells[key].content;

                if (!options.includes(option)) {
                  options.push(option);
                }
              }
            });
          }
        });
      }

      return options.map(function (option) {
        return {
          label: option,
          value: option
        };
      });
    }
  }, {
    key: "getPaginatedTable",
    value: function getPaginatedTable() {
      var _this$state2 = this.state,
          table = _this$state2.table,
          pagination = _this$state2.pagination;
      var rowsPerPage = this.props.rowsPerPage; // Create a deep copy

      var paginatedTable = JSON.parse(JSON.stringify(table));

      if (get(function () {
        return paginatedTable.bodies[0].rows;
      })) {
        var pageRows = paginatedTable.bodies[0].rows.filter(function (row) {
          return !row.hidden;
        }).slice((pagination.currentPage - 1) * rowsPerPage, pagination.currentPage * rowsPerPage);

        if (pageRows.length) {
          paginatedTable.bodies[0].rows = pageRows;
        }
      }

      return paginatedTable;
    }
  }, {
    key: "handleChange",
    value: function handleChange(optionsSelected, key) {
      // Create a deep copy
      var filter = JSON.parse(JSON.stringify(this.state.filter));
      var table = JSON.parse(JSON.stringify(this.state.table));
      var pagination = JSON.parse(JSON.stringify(this.state.pagination));
      var rowsPerPage = this.props.rowsPerPage;
      filter.cells.find(function (cell) {
        return cell.key === key;
      }).optionsSelected = optionsSelected;

      if (get(function () {
        return table.bodies[0].rows;
      })) {
        table.bodies[0].rows.forEach(function (row) {
          var filteredOut = row.cells.some(function (cell) {
            var filterCell = filter.cells.find(function (filterCellFind) {
              return filterCellFind.key === cell.key;
            });

            if (filterCell.optionsSelected && filterCell.optionsSelected.length) {
              return filterCell.optionsSelected.some(function (option) {
                return option.value === cell.content;
              }) === false;
            }

            return false;
          });
          row.hidden = filteredOut;
        });
        pagination.rows = table.bodies[0].rows.filter(function (row) {
          return !row.hidden;
        }).length;
        pagination.pages = Math.ceil(pagination.rows / rowsPerPage);
      }

      pagination.currentPage = 1;
      this.setState({
        filter: filter,
        table: table,
        pagination: pagination
      });
    }
  }]);

  return TableWithFilters;
}(Component);

_defineProperty(TableWithFilters, "displayName", "TableWithFilters");

_defineProperty(TableWithFilters, "propTypes", {
  /**
   * Data object to generate table and filters
   */
  data: PropTypes.object.isRequired,

  /**
   * Remove selected tag from available filter options
   */
  filtersHideSelectedOptions: PropTypes.bool,

  /**
   * Message displayed in a filter if there is no option resulting from the typeahead input
   */
  filtersNoOptionsMessage: PropTypes.string,

  /**
   * Placeholder for the filter input
   */
  filtersPlaceholder: PropTypes.string,

  /**
   * Information text below the title
   */
  infoText: PropTypes.string.isRequired,

  /**
   * Allow multiple tags to be selected in a filter
   */
  isMulti: PropTypes.bool,

  /**
   * Message displayed if there are no results in the table
   */
  noResultsMessage: PropTypes.string.isRequired,

  /**
   * Max number of pages shown in the pagination to be navigable directly
   */
  pagesNavigableOnSide: PropTypes.number.isRequired,

  /**
   * Text for pagination result summary
   */
  paginationResultSummaryText: PropTypes.string.isRequired,

  /**
   * Number of table rows displayed per page in pagination
   */
  rowsPerPage: PropTypes.number.isRequired,

  /**
   * Subtitle heading rank of the filters' panel
   */
  subtitleHeadingRank: PropTypes.oneOf(Object.values(Rank)),

  /**
   * Title of the filters' panel
   */
  title: PropTypes.string.isRequired,

  /**
   * Title heading rank of the filters' panel
   */
  titleHeadingRank: PropTypes.oneOf(Object.values(Rank))
});

_defineProperty(TableWithFilters, "defaultProps", {
  infoText: "Find a broker by asset, region, route or name.",
  noResultsMessage: "No results have been found as a result of the table being over-constrained. To see results, please try removing filters or try a different combination of filters to find the information you are looking for.",
  pagesNavigableOnSide: 2,
  paginationResultSummaryText: "Viewing {1} of {2} results:",
  rowsPerPage: 50,
  subtitleHeadingRank: "3",
  title: "Search Our Network",
  titleHeadingRank: Rank.Second
});

TableWithFilters.TagFilter = TagFilter;
TableWithFilters.Table = Table;
export default TableWithFilters;